import { isProdEnvironment } from '@bingads-webui-campaign-react/smart-page-util';

const isProdEnv = isProdEnvironment(document.domain);

const prodAppId = 'c97b71c8-e958-4ec9-a302-053aabc9890c';
const prodClientAppId = 'b024b9dc-dd00-4ebf-8f6c-84d7bd100853';
const prodAuthority = 'https://login.windows.net/common';

const testAppId = 'd203d5bc-88db-444a-9851-9e49d47cbf58';
const testClientAppId = '2b5ff9fc-fdc3-4d2d-a63a-13f62ce897dc';
const testAuthority = 'https://login.windows-ppe.net/common';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: isProdEnv ? prodClientAppId : testClientAppId,
    authority: isProdEnv ? prodAuthority : testAuthority,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    pollIntervalMilliseconds: 15,
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const customDomainLoginRequest = {
  scopes: [
    `api://${isProdEnv ? prodAppId : testAppId}/User.Write`,
  ],
};
